<app-data-table
  (removeFromPassedUsersEmitter)="removeFromPasseUsers($event)"
  (generateCertEmitter)="generateCertificate($event)"
  (viewCertEmitter)="viewCertificate($event)"
  [columns]="tableColumns"
  [data]="tableData"
  (fireGetServerData)="getServerData($event)"
  (getData)="getServerData($event)"
  [hasRemoveFromPassedUsers]="true"
  [hasGenerateCert]="true"
  [hasViewCert]="true"
  [total]="total"
  [next_page]="next_page"
  [pluralTableLabel]="'Passed users'"
  [singleTableLabel]="'Passed user'"
></app-data-table>
